import React from "react";
import { NumberInput } from "@revvsales/components";
import { numberForamting } from "../../../utils/globalUtils";

export default class GroupTitleComponent extends React.Component {
  state = {
    value: 0,
  };

  componentDidMount() {
    this.setState({ value: this.props.groupMeta.discount_percent });
  }

  _onChange = value => {
    this.setState({ value });
  };

  _onUpdatedDiscountValue = () => {
    this.props.onUpdatedDiscountValue(
      this.props.groupMeta,
      parseFloat(this.state.value),
    );
  };

  _onBlur = () => {
    if (this.state.value) {
      this._onUpdatedDiscountValue();
    } else {
      this.setState({ value: 0 }, () => {
        this._onUpdatedDiscountValue();
      });
    }
  };

  render() {
    const {
      isLocked,
      groupName,
      groupLength,
      groupMeta,
      currencyIcon,
    } = this.props;
    const {
      group_total: total,
      discountAmount,
      discountedGroupTotal,
    } = groupMeta;
    return (
      <React.Fragment>
        <div className="grouptitlerenderer-wrapper">
          <div className="grouptitlerenderer--group-title">
            {groupName} ({groupLength})
          </div>
          <div className="grouptitlerenderer-grouptotal-section">
            <div className="grouptitlerenderer-split-wrapper">
              <div className="grouptitlerenderer-grouptotal-split">
                <div className="grouptitlerenderer-title">
                  <span>Group Discount (%)</span>
                  <span> Group Discount ({currencyIcon})</span>
                </div>
                <div className="grouptitlerenderer-values">
                  <span className="grouptitlerenderer-discount-wrapper">
                    <NumberInput
                      className="grouptitlerenderer-discount-inp"
                      data-test="grouptitlerenderer-group-discount-inp"
                      disabled={isLocked}
                      isFloat
                      limitTo={100}
                      onChange={this._onChange}
                      onBlur={this._onBlur}
                      placeholder="Discount"
                      value={this.state.value}
                    />
                  </span>
                  <span>{numberForamting(discountAmount, "")}</span>
                </div>
              </div>
              <div className="grouptitlerenderer-grouptotal-split">
                <div className="grouptitlerenderer-title">
                  <span>Group Total:</span>
                  <span>Discounted Group Total:</span>
                </div>
                <div className="grouptitlerenderer-values">
                  <span>{numberForamting(total, currencyIcon)}</span>
                  <span>
                    {numberForamting(discountedGroupTotal, currencyIcon)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/commonComponents/CustomGrid/GroupTitle/GroupTitle.js